import { combineReducers } from "redux";
import notifications from "./notifications";
import orderForm from "./order-form";
import googleNotifications from "./google-notifications";
import mapsApiKeys from "./maps-api-keys";
import webBookingApiAccess from "./web-booking-api-access";
import webBookerSettings from "./web-booker-settings";

export default combineReducers({
  notifications,
  orderForm,
  googleNotifications,
  mapsApiKeys,
  webBookingApiAccess,
  webBookerSettings,
});
